module.exports = __webpack_public_path__ + "static/media/title-hero-7.7c6a5bd7.jpg";